export default "__VITE_ASSET__hsy3s$eL__"